import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import SafeIcon from '../common/SafeIcon';
import { FiShield } from 'react-icons/fi';

const GuaranteeLetter = () => {
  return (
    <SalesLetterWrapper className="pt-24">
      <div className="bg-bg-alt rounded-[4rem] p-12 md:p-20 border-2 border-brand-green/20 text-center relative overflow-hidden">
        <div className="absolute -top-10 -right-10 w-40 h-40 bg-brand-green/5 rounded-full blur-3xl"></div>
        
        <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-3xl shadow-sm text-brand-green mb-10 border border-slate-100">
          <SafeIcon icon={FiShield} className="text-5xl" />
        </div>
        
        <h2 className="text-3xl md:text-4xl font-display font-black text-brand-dark mb-8">
          30-Day Money-Back Guarantee
        </h2>
        
        <div className="space-y-8 text-xl leading-relaxed text-text-secondary max-w-2xl mx-auto">
          <p>Try the program for 30 full days.</p>
          <p>If you don’t feel: <span className="text-brand-dark font-bold italic">more confident, more informed, and more optimistic about creating flexible online income in retirement…</span></p>
          <p className="text-2xl font-black text-brand-dark">Simply email us for a full refund.</p>
          
          <div className="flex items-center gap-4 justify-center pt-8">
            <div className="h-px w-12 bg-slate-200"></div>
            <p className="text-xs font-black uppercase tracking-[0.3em] text-brand-dark">No pressure • No risk</p>
            <div className="h-px w-12 bg-slate-200"></div>
          </div>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default GuaranteeLetter;